import { StatusBar } from 'expo-status-bar'
import React, { useState } from 'react'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import useCachedResources from './hooks/useCachedResources'
import useColorScheme from './hooks/useColorScheme'
import Navigation from './navigation'
import { Provider } from 'react-redux'
import { store } from './state/store'
import { Linking, LogBox } from 'react-native'
import RetrieveData from './firebase/fbDataRetrieval/RetrieveData'
import qs from 'qs'
import RetrieveLocation from './firebase/fbDataRetrieval/RetrieveLocation'
import InternetConnection from './components/InternetConnection'
import TestModeBanner from './components/TestModeBanner'
import CustomAlert from './components/CustomAlert'
import { FirebaseAnalyticsProvider } from './context/FirebaseAnalyticsContext'
import { GoogleAnalyticsProvider } from './context/GoogleAnalyticsContext'
import { RetrieveDataProvider } from './context/RetrieveDataContext'

export default function App() {
	const [rCode, setRCode] = useState('')
	Linking.getInitialURL().then(url => {
		if (url) {
			const { referralCode } = qs.parse(url.split('?')[1])
			if (typeof referralCode === 'string') {
				setRCode(referralCode)
			}
		}
	})

	const isLoadingComplete = useCachedResources()

	// currently only light mode is supported.
	const colorScheme = useColorScheme()

	// This line will prevent displaying logs of this type in your emulator
	LogBox.ignoreLogs(['new NativeEventEmitter'])

	// This line will prevent displaying all warning logs in your emulator
	LogBox.ignoreAllLogs()
	if (!isLoadingComplete) {
		return null
	} else {
		return (
			<Provider store={store}>
				<GoogleAnalyticsProvider>
					<FirebaseAnalyticsProvider>
						<SafeAreaProvider>
							<TestModeBanner />
							<CustomAlert />
							<InternetConnection>
								<RetrieveDataProvider referralCode={rCode} loadingTracker={null}>
									<RetrieveData>
										<RetrieveLocation />
										<Navigation colorScheme={colorScheme} />
										<StatusBar />
									</RetrieveData>
								</RetrieveDataProvider>
							</InternetConnection>
						</SafeAreaProvider>
					</FirebaseAnalyticsProvider>
				</GoogleAnalyticsProvider>
			</Provider>
		)
	}
}
